export default "/images/97269748c17c036d1449728590861bb6.avif";